import TextIcon from "./TextIcon";
export default TextIcon;